import $, { get } from "jquery";
import * as GC from "../../../../../common/common";
import * as omnimap from "../../../../../../api/omnimap/omnimapActions";
import * as CommonFunctions from "../../common/commonFunctions";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList) => {

    var oTable = $("#example").dataTable();
    var isAdmin = false;
    var totalCount = 0;
    if (page_number === 1) {
      oTable.fnClearTable();
    }


  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        for (let i = 0; i < data.relationships.roles.length; i++) {
          if (
            data.relationships.roles[i].role.name ===
            "Administrator for NIEUWLAND"
          ) {
            isAdmin = true;
            totalCount++;

            break;
          } else {
            isAdmin = false;
          }
        }

        if (!isAdmin) {
          var circleType =
            data["can_login"] === true
              ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
              : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
          var alias =
            '<span class="text-dark font-weight-bold">' +
            data["alias"] +
            "</span>";
          var checkbox =
            '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';
          var email = `<a href="mailto:${data["email"]}">${data["email"]}</a>`;
          if (typeof email === "undefined") {
            email = "";
          }
          var organisatie = `<a name="${data.relationships.own_organisation.identification}" role="button" style="text-decoration: none;
          color: #2581cc;" id="user-organizitaion">${data.relationships.mandate_organisation["name"]}</a>`;
          if (typeof organisatie === "undefined") {
            organisatie = "";
          }
          var mandateOrganisatie =
            data.relationships.mandate_organisation["name"];
          if (typeof mandateOrganisatie === "undefined") {
            mandateOrganisatie = "";
          }
          var gebruikersrollen = "";
          data.relationships.roles.forEach((i) => {
            gebruikersrollen +=
              '<span class="text-dark font-weight-bold">' +
              i.role.name +
              "</span><br />";
          });
          if (typeof gebruikersrollen === "undefined") {
            gebruikersrollen = "";
          }

          var startDate = "";
          if (typeof data["valid_from"] !== "undefined") {
            startDate = GC.FormatDate(data["valid_from"], "withTime");
          }
          var model = {
            isActive: data["can_login"],
            identification: data["identification"],
            alias: data["alias"],
            email,
            organisatie,
            mandateOrganisatie,
            gebruikersrollen,
            startDate,
          };

          var test = {
            checkbox: checkbox,
            active: circleType,
            Alias: alias,
            Email: email,
            Gebruikersrollen: gebruikersrollen,
            Organisatie: organisatie,
            "Mandate organisatie": mandateOrganisatie,
            "Geldig van": startDate,
          };

          let _columnList = [];
          if (columnList && columnList.column_list){
            for (let column in columnList.column_list) {
              for (let key in test) {
                if (
                    columnList.column_list[column].toLowerCase() === key.toLowerCase()
                ) {
                  _columnList.push(test[key]);
                }
              }
            }
          }

          window.$catalog_users_Glist.push(model);
          var addId = oTable.fnAddData(
            [
              ..._columnList,
              // checkbox,
              // circleType,
              // alias,
              // email,
              // gebruikersrollen,
              // organisatie,
              // mandateOrganisatie,
              // startDate,
            ],
            false
          );

          if(addId.length > 0) {
            var theNode = $("#example").dataTable().fnSettings().aoData[
                addId[0]
                ].nTr;
            theNode.setAttribute("rowId", data["identification"]);
          }
        }
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }
  $("#total-rows").html(result.meta.total_found - totalCount);
  window.$catalog_users_total_row = result.meta.total_found - totalCount;
  // window.$catalog_users_real_total_row = result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$catalog_users_treeChangeStatus = true;
  window.$catalog_users_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data === "user-gebruikersrollen") {
    window.$catalog_users_gebruikersrollen.length = 0;
    $.each(result.data, function (index, data) {
      window.$catalog_users_gebruikersrollen.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "user-alias") {
    window.$catalog_users_user_alias.length = 0;
    $.each(result, function (index, data) {
      window.$catalog_users_user_alias.push(data);
    });
  }
  if (searchId === "user-email") {
    window.$catalog_users_user_email.length = 0;
    $.each(result, function (index, data) {
      window.$catalog_users_user_email.push(data);
    });
  }
  if (searchId === "user-gebruikersrollen") {
    window.$catalog_users_gebruikersrollen.length = 0;
    $.each(result.data, function (index, data) {
      window.$catalog_users_gebruikersrollen.push(data.name);
    });
  }
  if (searchId === "user-organisatie") {
    window.$catalog_users_organisatie.length = 0;
    $.each(result.data, function (index, data) {
      window.$catalog_users_organisatie.push(data.name);
    });
  }
};

export const UserCreatedCallBack = (token) => {
  GC.sleep(3000).then(() => {
    $("#add-user-modal").modal("hide");
    omnimap
      .GetAllUsersAction(1, 100, "", "", "", "", window.$catalog_users_token)
      .then((result) => {
        FillTableCallBack(result, 1, window.$catalog_users_columnListPure);
      });
  });
};
/**
 * * kullanıcı değişikliklerini dinamik olarak takip eder
 */
function getUserChanges(oldObject) {
  return new Promise((resolve) => {
    GC.sleep(1500).then(() => {
      omnimap
        .UserApiAction(
          window.$catalog_users_selectedRow.identification,
          "GET",
          null,
          null,
          window.$catalog_users_token
        )
        .then(async (d) => {
          if (JSON.stringify(d.data) === JSON.stringify(oldObject)) {
            resolve(getUserChanges());
          } else {
            let data = d.data;
            var gebruikersrollen = "";
            data.relationships.roles.forEach((i) => {
              gebruikersrollen +=
                '<span class="text-dark font-weight-bold">' +
                i.role.name +
                "</span><br />";
            });
            if (typeof gebruikersrollen === "undefined") {
              gebruikersrollen = "";
            }

            window.$catalog_users_selectedRow = {
              isActive: data["can_login"],
              identification: data["identification"],
              alias: data["alias"],
              email: data["email"],
              gebruikersrollen: gebruikersrollen,
              // organisatie,
              // mandateOrganisatie,
              // startDate,
            };

            await CommonFunctions.fillDetail();
            await resolve(true);
          }
        });
    });
  });
}
export const UserEditCallBack = () => {
  return new Promise((resolve) => {
    GC.sleep(1500).then(() => {
      $("#edit-user-modal").modal("hide");
      // CommonFunctions.fillDetail();
      omnimap
        .GetAllUsersAction(1, 100, "", "", "", "", window.$catalog_users_token)
        .then(async (result) => {
          FillTableCallBack(result, 1, window.$catalog_users_columnListPure);

          omnimap
            .UserApiAction(
              window.$catalog_users_selectedRow.identification,
              "GET",
              null,
              null,
              window.$catalog_users_token
            )
            .then(async (d) => {
              await getUserChanges(d.data).then((result) => {
                if (result) {
                  resolve(true);
                }
              });
            });
        });
    });
  });
};

/**
 * * tablo değişikliklerini dinamik olarak takip eder
 */
function getTable() {
  GC.sleep(1500).then(() => {
    omnimap
      .GetAllUsersAction(1, 100, "", "", "", "", window.$catalog_users_token)
      .then((result) => {
        if (window.$catalog_users_real_total_row != result.data.length) {
          FillTableCallBack(result, 1);
        } else getTable();
      });
  });
}

export const RowsDeletedCallBack = async (token) => {
  GC.sleep(500).then(() => {
    $("#user-delete-modal").modal("hide");
    omnimap
      .GetAllUsersAction(1, 100, "", "", "", "", window.$catalog_users_token)
      .then(async (result) => {
        window.$catalog_users_real_total_row = await result.data.length;
        FillTableCallBack(result, 1);
        await getTable();
      });
  });
};

export const GetActionsOfRowCallback = async (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];
  var BreakException = {};

  $("#myPopup").html("");
  $.each(window.$catalog_users_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(action["class"] + " catalog-action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  });

  /**
   *  * aktif olmayan actionlar burada listeleniyor.
   **/
  // $.each(actionsOfDisabled, function (index, action) {
  //   var anchor = $("<a disabled></a>")
  //     .attr({ href: "javascript:void(0)", id: action["identification"] })
  //     .addClass("disabled" + " catalog-action")
  //     .html(action["name"]);
  //   $("#myPopup").append(anchor);
  // });

  if (window.$catalog_users_selectedIds.length > 0) {
    var verwijderen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "user-verwijderen" })
      .addClass("trash-bin beheereenheid")
      .html("Gebruiker verwijderen");
    $("#myPopup").append(verwijderen);
  } else {
    var beheereenheidToevoegen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "cat-user-add" })
      .addClass("user beheereenheid")
      .html("Gebruiker toevoegen");
    $("#myPopup").append(beheereenheidToevoegen);
    var beheereenheidToevoegen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "cat-organisatie-add" })
      .addClass("")
      .html("Organisatie toevoegen");
    $("#myPopup").append(beheereenheidToevoegen);
  }
  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";
  var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
  test_list[statusIndex] = "active";
  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "catalog>gebruikersbeheer",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "catalog>gebruikersbeheer"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
